import { Inject, Injectable } from '@angular/core';
import { ReuseTabService } from '@delon/abc/reuse-tab';
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth';
import { SettingsService } from '@delon/theme';
import { NzSafeAny } from 'ng-zorro-antd/core/types';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

@Injectable({
  providedIn: 'root'
})
export class SupportAccessService {
  private _isSupport = false;
  interval$: NzSafeAny;

  constructor(
    public settings: SettingsService,
    private reuseTabSrv: ReuseTabService,
    private modalService: NzModalService,
    @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService
  ) {
    this._isSupport = this.settings.user['isSupport'];
  }

  restrictSupportAccess() {
    if (this._isSupport) {
      this.showModal();
    }
  }

  private showModal() {
    const modal: NzModalRef = this.modalService.create({
      nzTitle: 'QNE Support Access',
      nzClosable: false,
      nzMaskClosable: false,
      nzContent:
        'The owner have restricted support access to this company. Please contact the owner for access.',
      nzWidth: '600px',
      nzFooter: [
        {
          label: 'Switch Company',
          type: 'primary',
          onClick: () => {
            modal.destroy();
            this.handleSwitchCompany();
          }
        },
        {
          label: 'Signout',
          type: 'dashed',
          onClick: () => {
            modal.destroy();
            this.handleSignOut();
          }
        }
      ]
    });
  }

  private handleSwitchCompany() {
    window.location.href = '/#/account/companies';
    if (!window.app) window.app = {};
    window.app.forcereload = true;
    setTimeout(() => {
      this.reuseTabSrv.clear();
      window.location.reload();
    }, 100);
  }

  private handleSignOut() {
    this.tokenService.clear();
    window.location.href = '/#/passport/login';
    if (!window.app) window.app = {};
    window.app.forcereload = true;
    window.location.reload();
  }
}
